/**
 * Formaat omzetten — de tool woont in Flow (Full Frame-account). Menu en zoeken openen
 * hem direct in een nieuw tabblad; deze route vangt de overige ingangen op (snelkoppeling
 * op Home, bladwijzer) en stuurt door.
 */
import React, { useEffect } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { FORMAAT_OMZETTEN_URL } from '../../config/flowUrl';

export default function FormaatOmzetten() {
  useEffect(() => { window.location.replace(FORMAAT_OMZETTEN_URL); }, []);
  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, pt: { xs: 3, md: 5 } }}>
      <Typography sx={{ fontSize: '0.9rem', color: '#596063' }}>
        Je gaat naar Formaat omzetten in Flow…{' '}
        <Link href={FORMAAT_OMZETTEN_URL}>Lukt dat niet? Klik hier.</Link>
      </Typography>
    </Box>
  );
}
